import React, { useContext, useEffect } from "react";
import TestPlanInputForm from "../../input-components/test-plan/TestPlanInputForm";
import { Box } from "@mui/material";
import { TestPlanContext } from "../TestPlanPage";

const TestPlanInputPage=()=>{
    const {setTestPlanIdentifier,setTestPlanTypes,setTestPlanEnvironment, setTestPlanOutput} = useContext(TestPlanContext);

    useEffect(() => {
        setTestPlanIdentifier({});
        setTestPlanTypes({});
        setTestPlanEnvironment({});
        setTestPlanOutput({});
    }, []);
    return(
        <Box>
            <TestPlanInputForm/>
        </Box>
    )
};
 export default TestPlanInputPage;